import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Axios from "axios";
import daterangepicker from "daterangepicker"; // eslint-disable-line no-unused-vars
import ReactSelect from "react-select";
import { Doughnut } from "react-chartjs-2";
import $ from "jquery";
import moment from "moment";
import CustomScrollbars from "react-custom-scrollbars-2";

// require("datatables.net-buttons")();
// require("datatables.net-buttons/js/buttons.colVis.js")();
// require("datatables.net-buttons/js/buttons.print.js")();
// require("datatables.net-buttons/js/buttons.html5.js")();
const colors_in = [
  "rgba(99, 193, 50, .3)",
  "rgba(98, 144, 195, .3)",
  "rgba(255, 119, 0, .3)",
  "rgba(163, 0, 0, .3)",
  "rgba(49, 10, 49, .3)",
  "rgba(9, 82, 86, .3)",
  "rgba(255, 0, 110, .3)",
  "rgba(8, 3, 87, .3)",
  "rgba(114, 25, 90, .3)",
  "rgba(0, 79, 45, .3)",
];
const colors_out = colors_in.map((e) => e.replace(".3", 1));

export class TimeByItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      start_date_range: moment().subtract(1, "week").startOf("week").format("MM/DD/YYYY"),
      end_date_range: moment().subtract(1, "week").endOf("week").format("MM/DD/YYYY"),
      users: [],
      selected_users: [],
      times: [],
      donut_data: {
        labels: [], //["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
        datasets: [{}],
      },
    };
  }
  componentDidMount() {
    this.GetUsers();
    $("#daterange-selector").daterangepicker({
      alwaysShowCalendars: true,
      opens: "left",
      autoApply: true,
      ranges: {
        Today: [moment(), moment()],
        "This Week": [moment().startOf("week"), moment()],
        "Last Week": [moment().subtract(1, "week").startOf("week"), moment().subtract(1, "week").endOf("week")],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [moment().subtract("1", "month").startOf("month"), moment().subtract("1", "month").endOf("month")],
        "This Year": [moment().startOf("year"), moment()],
      },
    });
    $("#daterange-selector").on("apply.daterangepicker", (e) => {
      window.$("#report-submit").click();
    });
  }
  GetUsers = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/user/get/all", {
      "x-access-token": this.props.authToken,
    })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response["data"]["status"] === "success") {
          this.setState(
            {
              users: response["data"]["users"],
              selected_users: [
                response.data.users
                  .map((m) => {
                    return { label: m.first_name + " " + m.last_name, value: m.id, current_user: m.current_user };
                  })
                  .find((l) => l.current_user === 1),
              ],
            },
            () => {
              this.GetTimeEntries();
            },
          );
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  GetTimeEntries = () => {
    if (this.state.selected_users.length === 0) {
      return;
    }
    let dataObj = {
      "x-access-token": this.props.authToken,
      user_id: this.state.selected_users.map((item) => item.value),
      daterange: $("#daterange-selector").val(),
    };
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/time-entries/get/by-user", dataObj)
      .then((response) => {
        if (response.data.status === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again.");
        }
        if (response.data.status === "success") {
          if ($.fn.DataTable.isDataTable("#datatables-chart-1")) $("#datatables-chart-1").DataTable().destroy();

          this.setState({ times: response.data.data }, () => {
            $("#datatables-chart-1").DataTable({
              dom: "lBfrtip", //"lBfrtip",
              lengthMenu: [
                [10, 25, 50, -1],
                [10, 25, 50, "All"],
              ],
              order: [
                [0, "desc"],
                [1, "asc"],
                [2, "asc"],
              ],
              buttons: {
                buttons: ["print", "csv"],
                dom: {
                  button: {
                    className: "btn btn-info m-1 mt-0",
                  },
                },
              },
            });
            this.RedrawDonutChart();
            this.RedrawBarChart();
          });
        }
      })
      .catch((error) => {
        //handle errors
        console.log(error);
        if (error.response && error.response.status === 401) {
          this.props.setRelogRequired(true);
        }
        this.props.MakeNotification("error", "There was an error. Please try again.");
      })
      .then(() => {});
  };
  RedrawDonutChart = () => {
    //Donut Data
    let labels = [...new Set(this.state.times.map((item) => item.item_name))];
    let users = [...new Set(this.state.times.map((item) => item.time_by_id))];
    let data = users.map((l) => []);
    users.forEach((d, ind) => {
      labels.forEach((e) => {
        data[ind].push(
          this.state.times
            .filter((l) => l.item_name === e && l.time_by_id === d)
            .map((l) => l.hours)
            .reduce((p, c) => {
              return p + c;
            }, 0),
        );
      });
    });
    let totalHours = [];
    this.state.selected_users.forEach((e) => {
      totalHours.push(
        this.state.times
          .filter((l) => l.time_by_id === e.value)
          .map((item) => item.hours)
          .reduce((p, c) => p + c, 0),
      );
    });
    let datasets = [];
    users.forEach((l, i) => {
      datasets.push({
        data: data[i],
        label: this.state.selected_users.find((m) => m.value === l).label,
        backgroundColor: colors_in,
        borderColor: colors_out,
        borderWidth: 2,
      });
    });
    this.setState((prevState) => {
      return {
        ...prevState,
        donut_data: {
          ...prevState.donut_data,
          datasets: datasets,
          labels: labels,
        },
      };
    });
    //Donut Options
    this.setState(
      (prevState) => {
        return {
          ...prevState,
          donut_options: {
            plugins: {
              title: { text: "Time by Item", display: true },
              legend: { position: "left" },
              tooltip: {
                callbacks: {
                  title: (tooltipItems, data) => {
                    return tooltipItems[0].dataset.label + " - " + tooltipItems[0].label;
                  },
                  label: (tooltipItems, data) => {
                    return (
                      this.props.FormatNumberTwoDecimals(tooltipItems.formattedValue) +
                      " hours (" +
                      this.props.FormatNumberTwoDecimals((tooltipItems.formattedValue / totalHours[tooltipItems.datasetIndex]) * 100) +
                      "%)"
                    );
                  },
                },
              },
            },
          },
        };
      },
      () => {
        $("#chart-1-accompany").css("max-height", $("#chart-1-holder").height());
      },
    );
  };
  RedrawBarChart = () => {
    //Bar Data
    let start = moment($("#daterange-selector").data("daterangepicker").startDate).startOf("day");
    let end = $("#daterange-selector").data("daterangepicker").endDate.startOf("day");
    let dates = [];
    for (let i = 0; i < start.isSameOrBefore(end); start.add(1, "days")) {
      dates.push(start.format("MM/DD/YYYY"));
    }
    let labels = [...new Set(this.state.times.map((item) => item.item_name))];
    let users = [...new Set(this.state.times.map((item) => item.time_by_id))];
    let datasets = [];
    labels.forEach((l, i) => {
      users.forEach((u, j) => {
        let d = [];
        dates.forEach((date) => {
          d.push(
            this.state.times
              .map((f) => {
                return { ...f, time_at: moment(f.time_at).startOf("day").format("MM/DD/YYYY") };
              })
              .filter((t) => t.time_by_id === u && t.item_name === l && t.time_at === date)
              .reduce((a, b) => {
                return a + b.hours;
              }, 0),
          );
        });
        datasets.push({ stack: u, label: l, backgroundColor: colors_in[i % colors_in.length], borderColor: colors_out[i % colors_out.length], borderWidth: 1, data: d });
      });
    });
    this.setState({
      bar_data: {
        labels: dates,
        datasets: datasets,
      },
      bar_options: {
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
            },
          ],
        },
      },
    });
    //Bar Options
    this.setState((prevState) => {
      return {
        ...prevState,
        bar_options: {
          plugins: {
            title: { text: "Daily Time by Item", display: true },
            legend: { position: "left" },
            tooltip: {
              callbacks: {
                title: (tooltipItems, data) => {
                  return this.state.users.find((f) => f.id === tooltipItems[0].dataset.stack).full_name + " - " + tooltipItems[0].label;
                },
                label: (tooltipItems, data) => {
                  return tooltipItems.dataset.label + " - " + this.props.FormatNumberTwoDecimals(tooltipItems.formattedValue) + " hours";
                },
              },
            },
          },
        },
      };
    });
  };

  render() {
    return (
      <main className="content">
        <div className="container-fluid">
          <div className="header">
            <h1 className="header-title">Time by Item</h1>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header row">
                  <div className="card-actions float-end">
                    {/* <a href="#" className="me-1">
                      <FontAwesomeIcon icon="sync" id="clients-list-refresh" onClick={this.GetItems} />
                    </a>
                    <a href="#" className="me-1">
                      <FontAwesomeIcon icon="plus" id="clients-list-refresh" onClick={this.PrepAddItem} />
                    </a> */}
                  </div>
                  <div className="col-md-12">
                    <h5 className="card-title mb-0">Time by Item</h5>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-1">
                    <div className="col-sm-12 col-md-6 col-lg-3">
                      <ReactSelect
                        isMulti={true}
                        options={this.state.users
                          .sort((a, b) => {
                            return a.current_user < b.current_user;
                          })
                          .map((e) => {
                            return { label: e.first_name + " " + e.last_name, value: e.id };
                          })}
                        value={this.state.selected_users}
                        onChange={(e) => {
                          this.setState({ selected_users: e }, () => {
                            this.GetTimeEntries();
                          });
                        }}
                      />
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-3">
                      <input className="form-control" type="text" id="daterange-selector" defaultValue={this.state.start_date_range + " - " + this.state.end_date_range} />
                    </div>
                    <div className="col-sm-12 col-md-1 col-xl-1">
                      <button id="report-submit" className="btn btn-primary" onClick={this.GetTimeEntries}>
                        Submit
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-5">
                      <div className="row">
                        <div className="col-md-4 offset-md-8 text-right">
                          <span className="clickable" data-bs-toggle="dropdown" data-bs-display="chart-dropdown">
                            <FontAwesomeIcon icon="ellipsis-h" className=" clickable m-2 pe-none" />
                          </span>
                          <div class="dropdown-menu dropdown-menu-end " data-bs-popper="chart-dropdown">
                            {/* <div class="dropdown-menu mb-2" style={{ position: "static", display: "block" }}> */}
                            <h6 class="dropdown-header">Toggle Data Fields</h6>
                            <span class="dropdown-item clickable" onClick={this.SelectAllChartOptions}>
                              Do Something
                            </span>
                            <span class="dropdown-item clickable" onClick={this.DeselectAllChartOptions}>
                              Do Something Else
                            </span>
                            {/* <a class="dropdown-item" href="#">
                              Something else here
                            </a> */}
                            {/* </div> */}
                          </div>
                        </div>
                      </div>
                      <div id="chart-1-holder" style={{ minHeight: "600px" }}>
                        <Doughnut data={this.state.donut_data} options={this.state.donut_options} />
                      </div>
                    </div>
                    <div className="col-md-7 ">
                      <CustomScrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                        <div id="chart-1-accompany">
                          <table id="datatables-chart-1" className="table table-striped" style={{ width: "100%" }}>
                            {/* Table header */}
                            <thead>
                              <tr>
                                <th>User</th>
                                <th>Date</th>
                                <th>Item</th>
                                <th>Hours</th>
                              </tr>
                            </thead>
                            {/* Table body */}
                            <tbody id="clients-table-body">
                              {this.state.times.map((time, i) => (
                                <tr key={time.id}>
                                  <td>{time.time_by}</td>
                                  <td>{this.props.MakeDateTimeReadable(time.time_at)}</td>
                                  <td>{time.item_name}</td>
                                  <td>{this.props.FormatNumberTwoDecimals(time.hours)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </CustomScrollbars>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default TimeByItem;
